import { render } from "./Statistic.vue?vue&type=template&id=41702c44&scoped=true"
import script from "./Statistic.vue?vue&type=script&lang=js"
export * from "./Statistic.vue?vue&type=script&lang=js"

import "./Statistic.vue?vue&type=style&index=0&id=41702c44&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41702c44"]])

export default __exports__